import React, { Component } from 'react';
import QvrfComponent from '../../../common/Qlik/QvrfComponent';
import PropTypes from 'prop-types';
import { Button, Grid, Paper, Tooltip, Badge } from '@material-ui/core';
import * as Icon from '@material-ui/icons';
import clsx from 'clsx';
import { colorSet } from '../../../../utils/Theme';
import Box from '../../../UI/Box';
import QvrfContainer from 'components/qvrf_component/QvrfContainer';
import FormLayout from '../../../common/FormLayout';
import config from 'coeus.config';
import FormEntryButton from 'components/settings/Pages/Partials/RowButtons/FormEntryButton';

class AdminContentManager extends Component {
    constructor(props) {
        super(props);
        this.state = {
            rows: null,
            qsObjects: null,
            deleteRowID: null,
            deleteObjectID: null,
            loading: true,
        };
    }

    deleteRowAction = (page, row) => {
        this.props.deleteRowAction(page, row);
    };

    deleteObjectAction = (page, object) => {
        this.props.deleteObjectAction(page, object);
    };

    render() {
        const { page, qssOptions, classes, history } = this.props;
        const { deleteRowID, deleteObjectID } = this.state;
        return (
            <div>
                {page &&
                    page.contentRows &&
                    page.contentRows.map((row) => (
                        <Box
                            component="span"
                            style={{
                                borderBottom: `5px solid ${colorSet.primary}`,
                            }}
                            className={clsx('u-pv-medium')}
                            key={row._id}
                        >
                            {row._id === deleteRowID && (
                                <Box
                                    component="span"
                                    style={{
                                        width: '100%',
                                        height: row.height,
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                    }}
                                >
                                    <Button
                                        style={{ margin: 5 }}
                                        startIcon={<Icon.Cancel />}
                                        className={` ${classes.buttonSecondary}`}
                                        aria-label="Cancel"
                                        onClick={() =>
                                            this.setState({ deleteRowID: null })
                                        }
                                    >
                                        {'CANCEL '}
                                    </Button>

                                    <Button
                                        style={{ margin: 5 }}
                                        startIcon={<Icon.Delete />}
                                        className={` ${classes.buttonPrimary}`}
                                        aria-label="Confirm Delete "
                                        onClick={() =>
                                            this.deleteRowAction(
                                                page._id,
                                                row._id
                                            )
                                        }
                                    >
                                        {'DELETE'}
                                    </Button>
                                </Box>
                            )}
                            {row._id !== deleteRowID && (
                                <Grid container spacing={1}>
                                    {row.objects &&
                                        row.objects.map((object) => {
                                            let editObjectString;

                                            switch (object.type) {
                                                case 'formObject':
                                                    editObjectString = `/settings/pages/form-object/${page._id}/${row._id}/object/${object._id}`;
                                                    break;
                                                case 'draftObject':
                                                    editObjectString = `/settings/pages/edit-wysiwyg-object/${page._id}/${object._id}`;
                                                    break;
                                                default:
                                                    editObjectString = `/settings/pages/edit-object/${page._id}/${object._id}`;
                                            }

                                            return (
                                                <Grid
                                                    key={object._id}
                                                    item
                                                    xs={object.size.xs}
                                                    sm={
                                                        object.size.sm ||
                                                        object.size.xs
                                                    }
                                                    md={
                                                        object.size.md ||
                                                        object.size.xs
                                                    }
                                                >
                                                    {object._id ===
                                                        deleteObjectID && (
                                                        <Box component="span">
                                                            <Box
                                                                component="span"
                                                                className={clsx(
                                                                    'u-m-xsmall u-p-small'
                                                                )}
                                                                style={{
                                                                    width: '100%',
                                                                    height:
                                                                        parseInt(
                                                                            row.height
                                                                        ) + 170,
                                                                    display:
                                                                        'flex',
                                                                    justifyContent:
                                                                        'center',
                                                                    alignItems:
                                                                        'center',
                                                                }}
                                                            >
                                                                <Button
                                                                    style={{
                                                                        margin: 5,
                                                                    }}
                                                                    startIcon={
                                                                        <Icon.Cancel />
                                                                    }
                                                                    className={` ${classes.buttonSecondary}`}
                                                                    aria-label="Cancel"
                                                                    onClick={() =>
                                                                        this.setState(
                                                                            {
                                                                                deleteObjectID:
                                                                                    null,
                                                                            }
                                                                        )
                                                                    }
                                                                >
                                                                    {object.size
                                                                        .md >
                                                                        1 &&
                                                                        'Cancel'}
                                                                </Button>

                                                                <Button
                                                                    style={{
                                                                        margin: 5,
                                                                    }}
                                                                    startIcon={
                                                                        <Icon.Delete />
                                                                    }
                                                                    className={` ${classes.buttonPrimary}`}
                                                                    aria-label="Confirm Delete "
                                                                    onClick={() =>
                                                                        this.deleteObjectAction(
                                                                            page._id,
                                                                            object._id
                                                                        )
                                                                    }
                                                                >
                                                                    {object.size
                                                                        .md >
                                                                        1 &&
                                                                        'DELETE'}
                                                                </Button>
                                                            </Box>
                                                        </Box>
                                                    )}
                                                    {object._id !==
                                                        deleteObjectID && (
                                                        <Paper
                                                            className={clsx(
                                                                'u-m-xsmall u-p-small'
                                                            )}
                                                        >
                                                            <Box component="span">
                                                                {qssOptions &&
                                                                    object.type !==
                                                                        'draftObject' &&
                                                                    object.type !==
                                                                        'formObject' && (
                                                                        <QvrfContainer
                                                                            loaderHeight={
                                                                                row.height
                                                                            }
                                                                            config={
                                                                                qssOptions.config
                                                                            }
                                                                        >
                                                                            <QvrfComponent
                                                                                options={
                                                                                    qssOptions
                                                                                }
                                                                                type={
                                                                                    object.type ||
                                                                                    'QdtViz'
                                                                                }
                                                                                props={{
                                                                                    type: null,
                                                                                    id: object.qsId,
                                                                                    height: `${parseInt(
                                                                                        row.height
                                                                                    )}px`,
                                                                                }}
                                                                            />
                                                                        </QvrfContainer>
                                                                    )}
                                                                {object.editorState &&
                                                                    object.type ===
                                                                        'draftObject' && (
                                                                        <div
                                                                            dangerouslySetInnerHTML={{
                                                                                __html: object.editorState,
                                                                            }}
                                                                        />
                                                                    )}
                                                                {object.type ===
                                                                    'formObject' && (
                                                                    <FormLayout
                                                                        object={
                                                                            object
                                                                        }
                                                                    />
                                                                )}
                                                            </Box>

                                                            <Box
                                                                component="span"
                                                                className={
                                                                    'u-mt-small'
                                                                }
                                                            >
                                                                <Tooltip
                                                                    title={
                                                                        'Edit Object'
                                                                    }
                                                                    placement={
                                                                        'top'
                                                                    }
                                                                >
                                                                    <Button
                                                                        className={clsx(
                                                                            classes.buttonSecondary,
                                                                            'c-btn--small u-p-zero u-mr-small'
                                                                        )}
                                                                        aria-label={
                                                                            'edit object'
                                                                        }
                                                                        onClick={() =>
                                                                            history.push(
                                                                                editObjectString
                                                                            )
                                                                        }
                                                                    >
                                                                        <Icon.Edit />
                                                                    </Button>
                                                                </Tooltip>
                                                                <Tooltip
                                                                    title={
                                                                        'Delete Object'
                                                                    }
                                                                    placement={
                                                                        'top'
                                                                    }
                                                                >
                                                                    <Button
                                                                        className={clsx(
                                                                            classes.buttonSecondary,
                                                                            'c-btn--small u-p-zero u-mr-small'
                                                                        )}
                                                                        aria-label={
                                                                            'edit object'
                                                                        }
                                                                        onClick={() =>
                                                                            this.setState(
                                                                                {
                                                                                    deleteObjectID:
                                                                                        object._id,
                                                                                }
                                                                            )
                                                                        }
                                                                    >
                                                                        <Icon.Delete />
                                                                    </Button>
                                                                </Tooltip>
                                                            </Box>
                                                        </Paper>
                                                    )}
                                                </Grid>
                                            );
                                        })}

                                    <Grid item sm={12}>
                                        <Box
                                            component="span"
                                            style={{
                                                width: '100%',
                                                height: 30,
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                            }}
                                        >
                                            <Tooltip
                                                title={'New Qlik Object'}
                                                placement={'top'}
                                            >
                                                <Button
                                                    className={clsx(
                                                        classes.buttonSecondary,
                                                        'u-mr-small u-p-zero  c-btn--small'
                                                    )}
                                                    onClick={() =>
                                                        history.push(
                                                            `/settings/pages/create-object/${page._id}/${row._id}/${row.objects.length}`
                                                        )
                                                    }
                                                >
                                                    <Icon.BarChartOutlined />
                                                </Button>
                                            </Tooltip>
                                            {config.feature.form_entry
                                                .enabled && (
                                                <FormEntryButton
                                                    pageId={page._id}
                                                    rowId={row._id}
                                                    classes={classes}
                                                />
                                            )}
                                            <Tooltip
                                                title={'New HTML Object'}
                                                placement={'top'}
                                            >
                                                <Button
                                                    className={clsx(
                                                        classes.buttonSecondary,
                                                        'u-mr-small u-p-zero  c-btn--small'
                                                    )}
                                                    onClick={() =>
                                                        history.push(
                                                            `/settings/pages/create-wysiwyg-object/${page._id}/${row._id}/${row.objects.length}`
                                                        )
                                                    }
                                                >
                                                    <Icon.CodeOutlined />
                                                </Button>
                                            </Tooltip>
                                            <Tooltip
                                                title={'Edit row'}
                                                placement={'top'}
                                            >
                                                <Button
                                                    className={clsx(
                                                        classes.buttonSecondary,
                                                        'u-mr-small u-p-zero c-btn--small'
                                                    )}
                                                    onClick={() => {
                                                        history.push(
                                                            `/settings/pages/rows/edit/${page._id}/${row._id}`
                                                        );
                                                    }}
                                                >
                                                    <Icon.Edit />
                                                </Button>
                                            </Tooltip>
                                            <Tooltip
                                                title={'Delete row and objects'}
                                                placement={'top'}
                                            >
                                                <Button
                                                    className={clsx(
                                                        classes.buttonSecondary,
                                                        'u-mr-small u-p-zero c-btn--small'
                                                    )}
                                                    onClick={() => {
                                                        this.setState({
                                                            deleteRowID:
                                                                row._id,
                                                        });
                                                    }}
                                                >
                                                    <Icon.Delete size={5} />
                                                </Button>
                                            </Tooltip>
                                        </Box>
                                    </Grid>
                                </Grid>
                            )}
                        </Box>
                    ))}
                <Grid container spacing={1}>
                    <Grid item xs={12}>
                        <Paper
                            className={clsx('u-m-xsmall u-p-small')}
                            elevation={2}
                        >
                            <Box
                                component="span"
                                style={{
                                    height: 150,
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                }}
                            >
                                <Button
                                    onClick={() =>
                                        history.push(
                                            `/settings/pages/create-row/${page._id}`
                                        )
                                    }
                                    className={`c-btn ${classes.buttonPrimary}`}
                                >
                                    NEW ROW
                                </Button>
                            </Box>
                        </Paper>
                    </Grid>
                </Grid>
            </div>
        );
    }
}

AdminContentManager.propTypes = {
    classes: PropTypes.object,
    page: PropTypes.object,
    deleteObjectAction: PropTypes.func,
    deleteRowAction: PropTypes.func,
    qssOptions: PropTypes.object,
    history: PropTypes.object,
};

export default AdminContentManager;
